Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        redirect: {
            name: "broadcast"
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        component: () =>
            import ('@/components/information/broadcast.vue'),
    },
    {
        path: '/reportCar',
        name: 'reportCar',
        component: () =>
            import ('@/components/information/reportCar.vue'),
    },
    {
        path: '/financeCar',
        name: 'financeCar',
        component: () =>
            import ('@/components/information/financeCar.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () =>
            import ('@/components/information/project.vue'),
    },
    {
        path: '/shortvideo',
        name: 'shortvideo',
        component: () =>
            import ('@/components/information/shortvideo.vue'),
    },
    {
        path: '/report',
        name: 'report',
        component: () =>
            import ('@/components/research/report.vue'),
    },
    {
        path: '/list',
        name: 'list',
        component: () =>
            import ('@/components/research/list.vue'),
    },
    {
        path: '/evaluation',
        name: 'evaluation',
        component: () =>
            import ('@/components/research/evaluation.vue'),
    },
    {
        path: '/complainList',
        name: 'complainList',
        component: () =>
            import ('@/components/complaints/complainList.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router